import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">MyBdayCard · Personalized Gifts</p>
        <h1>Celebrate Every Birthday with a Personal Touch</h1>
        <p className="lede">
          Discover our unique collection of personalized birthday cards and gifts. Customize your selections and enjoy hassle-free delivery right to your doorstep.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_self">
            Shop Now
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Unique Designs</h2>
          <p>
            Choose from a variety of exclusive designs that can be tailored to fit any personality and occasion.
          </p>
        </article>
        <article>
          <h2>Easy Customization</h2>
          <p>
            Personalize your cards and gifts with names, messages, and photos to create unforgettable memories.
          </p>
        </article>
        <article>
          <h2>Reliable Delivery</h2>
          <p>
            Enjoy peace of mind with our prompt delivery service, ensuring your thoughtful gifts arrive on time.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;